import React from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import { useOnboarding } from '../../contexts/OnboardingContext';

interface RestartTourButtonProps {
    className?: string;
}

const RestartTourButton: React.FC<RestartTourButtonProps> = ({ className = '' }) => {
    const { showTour } = useOnboarding();

    return (
        <button
            onClick={showTour}
            className={`inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${className}`}
            aria-label="Restart Onboarding Tour"
        >
            <QuestionMarkCircleIcon className="h-5 w-5 mr-2" />
            <span>Restart Tour</span>
        </button>
    );
};

export default RestartTourButton; 